export default __webpack_public_path__ + "static/media/351.8fa6ab6d.png";